import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { useAppSelector } from "../hook";

export type AssetTreeProps = {
  selectedCategories: string[];
  selectedClients: string[];
  selectedContracts: string[];
  selectedVehicles: string[];
};

const initialState: AssetTreeProps = {
  selectedCategories: [],
  selectedClients: [],
  selectedContracts: [],
  selectedVehicles: [],
};

export const VolksAssetTreeSlice = createSlice({
  name: "volksAssetTree",
  initialState,
  reducers: {
    setSelectedCategories: (state, action: PayloadAction<string[]>) => {
      state.selectedCategories = action.payload;
    },
    setSelectedClients: (state, action: PayloadAction<string[]>) => {
      state.selectedClients = action.payload;
    },
    setSelectedContracts: (state, action: PayloadAction<string[]>) => {
      state.selectedContracts = action.payload;
    },
    setSelectedVehicles: (state, action: PayloadAction<string[]>) => {
      state.selectedVehicles = action.payload;
    },
  },
});

export const { setSelectedCategories, setSelectedClients, setSelectedContracts, setSelectedVehicles } =
  VolksAssetTreeSlice.actions;

export const getStoredSelectedCategories = (state: RootState) => state.volksAssetTree.selectedCategories;
export const getStoredSelectedClients = (state: RootState) => state.volksAssetTree.selectedClients;
export const getStoredSelectedContracts = (state: RootState) => state.volksAssetTree.selectedContracts;
export const getStoredSelectedVehicles = (state: RootState) => state.volksAssetTree.selectedVehicles;

export const useGetStoredSelectedCategories = () => useAppSelector(getStoredSelectedCategories);
export const useGetStoredSelectedClients = () => useAppSelector(getStoredSelectedClients);
export const useGetStoredSelectedContracts = () => useAppSelector(getStoredSelectedContracts);
export const useGetStoredSelectedVehicles = () => useAppSelector(getStoredSelectedVehicles);

export default VolksAssetTreeSlice.reducer;
